import { debounce } from 'lodash';
import React, { useState } from 'react';
import { TextField } from 'vkit/lib/components';

const Search: React.FC = () => {
  const [searchedFile, setSearchedFile] = useState<string>('');

  const onSearch = debounce((value: string) => setSearchedFile(value), 500);

  return (
    <TextField
      small
      clearable
      icon='search-outline'
      iconDir='right'
      value={searchedFile}
      onChange={onSearch}
    />
  );
};

export default Search;
